import { useEffect, useState } from "react";
import Notification from "../../../../components/toast";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { schema } from "./schema";
import { is } from "date-fns/locale";
import LibBoolean from "../../../../util/libBool";

export const IndexHook = ({
	isOpenModalRegister,
	ident,
	idTable,
	selectedData,
	setSelectData,
	fetchID,
	reloadData,
	insert,
}) => {
	const {
		register,
		handleSubmit,
		setValue,
		setFocus,
		setError,
		reset,
		control,
		formState: { errors, isSubmitting },
	} = useForm({
		mode: "onSubmit",
		//quando revalidar os campos
		resolver: zodResolver(schema),
		defaultValues: {
			id_forma: 0,
			nome: "",
			ativo: true,
		},
	});

	// const [id_forma, setid_forma] = useState(0);

	const [loading, setLoading] = useState(false);

	const handleCloseModalRegister = () => {
		const event = new CustomEvent(`${ident}`);
		window.dispatchEvent(event);
	};

	//#region Fetch
	useEffect(() => {
		if (isOpenModalRegister) {
			const id =
				typeof selectedData[idTable] === "number" && !isNaN(selectedData[idTable]) ? selectedData[idTable] : 0;

			if (id > 0) {
				fetch(id);
			}
		} else {
			if (setSelectData) setSelectData({});

			reset();
		}
	}, [isOpenModalRegister, selectedData]);

	const fetch = async (id) => {
		try {
			setLoading(true);

			const response = await fetchID(id);

			if (response.data && typeof response.data === "object") {
				const data = response.data;

				// const newData = await processNewData(data);

				Object.keys(data).forEach((field) => {
					setValue(field, data[field]);
				});
			}
		} catch (error) {
			Notification.showToast({
				message: error.message,
				type: "warning",
			});
		} finally {
			setLoading(false);
		}
	};

	// const processNewData = async (data) => {
	// 	return {
	// 		...data,
	// 		ativo: LibBoolean.strToBoolean(data.ativo),
	// 	};
	// };
	//#endregion

	//#region onSubmit
	const handleOnSubmit = async (data) => {
		try {
			let response;

			// const newDate = ValidateSubmit(data);

			response = await insert(data);

			const currentId = response.data[idTable];

			await reloadData(data[idTable], currentId);

			Notification.showToast({
				message: "Registro salvo com sucesso.",
				type: "success",
			});
			reset();
			handleCloseModalRegister();
		} catch (error) {
			if (error.field && error.field !== "ID_FORMA") {
				// errosAfterPost(error.field, error.message);
			} else
				Notification.showToast({
					message: error.message,
					type: "error",
				});
		}
	};

	const ValidateSubmit = (data) => {
		// const newAtivo = LibBoolean.booleanToStr(data.ativo);
		// const newData = {
		// 	...data,
		// 	ativo: newAtivo,
		// };
		// return newData;
	};

	//#endregion

	return {
		//hooks
		handleOnSubmit,
		handleCloseModalRegister,

		//useForm
		register,
		handleSubmit,
		setValue,
		control,
		setFocus,

		loading,
		//formState
		errors,
		isSubmitting,
	};
};
